/**
 * Price utility functions for currency conversion
 */
import axios from 'axios';
import config from '../config';

let cachedExchangeRates = null;
let exchangeRatesPromise = null;

const fetchExchangeRates = async () => {
    if (cachedExchangeRates !== null) {
        return cachedExchangeRates;
    }

    if (exchangeRatesPromise === null) {
        exchangeRatesPromise = axios.get('https://finans.truncgil.com/v4/today.json')
            .then(response => {
                // API'den gelen verileri işle
                const rates = {
                    EUR: {
                        rate: parseFloat(response.data.EUR.Buying)
                    },
                    USD: {
                        rate: parseFloat(response.data.USD.Buying)
                    },
                    TRY: {
                        rate: 1
                    }
                };
                
                cachedExchangeRates = rates;
                // 1 saat sonra cache'i temizle
                setTimeout(() => {
                    cachedExchangeRates = null;
                }, 3600000);
                return cachedExchangeRates;
            })
            .catch(error => {
                console.error("Error fetching exchange rates:", error);
                return null;
            })
            .finally(() => {
                exchangeRatesPromise = null;
            });
    }

    return exchangeRatesPromise;
};

export const getPrice = async (basePrice, token, targetCurrency = 'EUR', taxes = null, countryCode = null, sourceCurrency = 'EUR') => {
    if (!basePrice || basePrice === "0.00") return "0.00";
    const price = Number(basePrice);
    if (isNaN(price)) return "0.00";

    // Eğer kaynak para birimi EUR ise ve hedef para birimi de EUR ise direkt dön
    if (sourceCurrency === 'EUR' && targetCurrency === 'EUR') {
        return price.toFixed(2);
    }

    try {
        const rates = await fetchExchangeRates();
        if (!rates) {
            console.error('Exchange rates not available');
            return price.toFixed(2);
        }

        // Kaynak para biriminden TRY'ye çevir
        let priceInTry;
        if (sourceCurrency === 'EUR') {
            const eurToTry = rates.EUR.rate;
            priceInTry = price * eurToTry;
        } else if (sourceCurrency === 'USD') {
            const usdToTry = rates.USD.rate;
            priceInTry = price * usdToTry;
        } else {
            // Diğer para birimleri için
            const sourceRate = rates[sourceCurrency]?.rate;
            if (!sourceRate) {
                console.error(`Exchange rate not available for ${sourceCurrency}`);
                return price.toFixed(2);
            }
            priceInTry = price * sourceRate;
        }

        // TRY'den hedef para birimine çevir
        if (targetCurrency === 'TRY') {
            return priceInTry.toFixed(2);
        } else if (targetCurrency === 'EUR') {
            const tryToEur = 1 / rates.EUR.rate;
            const convertedPrice = priceInTry * tryToEur;
            return convertedPrice.toFixed(2);
        } else if (targetCurrency === 'USD') {
            const tryToUsd = 1 / rates.USD.rate;
            const convertedPrice = priceInTry * tryToUsd;
            return convertedPrice.toFixed(2);
        } else {
            const targetRate = rates[targetCurrency]?.rate;
            if (!targetRate) {
                console.error(`Exchange rate not available for ${targetCurrency}`);
                return price.toFixed(2);
            }
            const convertedPrice = priceInTry / targetRate;
            return convertedPrice.toFixed(2);
        }
    } catch (error) {
        console.error('Currency conversion error:', error);
        return price.toFixed(2);
    }
};

// Cache'i sıfırlamak için
export const clearCache = () => {
    cachedExchangeRates = null;
    exchangeRatesPromise = null;
};

// Para birimi formatlamak için yardımcı fonksiyon
export const formatPrice = (amount, currency) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
    }).format(amount);
};